<h2 mat-dialog-title>Add New Day</h2>
<mat-dialog-content>
  <form #form="ngForm">
    <div class="form-row">
      <mat-form-field appearance="fill" class="field-small">
        <mat-label>Column Day (e.g. 20)</mat-label>
        <input matInput [(ngModel)]="newDay" name="day" type="number" required min="0" />
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="fill" class="field-small">
        <mat-label>Default PCT (%)</mat-label>
        <input matInput [(ngModel)]="defaultPct" name="pct" type="number" min="-100" max="100" />
      </mat-form-field>
    </div>

    @if (errorMsg) {
      <div class="text-danger">{{ errorMsg }}</div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-button color="primary" (click)="submit()">Add</button>
</mat-dialog-actions>
